module.exports = __webpack_public_path__ + "static/media/stress-management@3x.abf1e7a9.png";